import Container from 'semantic-ui-react/dist/commonjs/elements/Container';
import '@purple/semantic-ui-purple-theme/components/container.css';

export default Container;
